// Services
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import Paper from "@material-ui/core/Paper";
import Buttons from "./buttons";
import { button_data2 } from "./ContainerButtons";
import { useEffect } from "react";
import { useState } from "react";
import "./Trending.css";
import { openVideoPopup } from "../../../Redux/Actions/PopupActions";
import { useDispatch } from "react-redux";
import LimitedTextContainer from "./LimitedText/LimitedTextContainer";

const HomeTrending = () => {
  const schoolId = getFromLocalStorage("schoolId");
  const [trendingVideos, setTrendingVideos] = useState([]);
  const [activeBtn, setActiveBtn] = useState(button_data2[0].value);
  const [checkBackId, setCheckBackId] = useState(null);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    getTrendingData();
  }, []);

  const getTrendingData = () => {
    setError("");
    userService
      .getTrendingDetails(schoolId)
      .then((res) => {
        const data = res?.data?.data?.shareMediaDetailsResponses;
        setTrendingVideos(data ? data : []);
      })
      .catch((err) => {
        setError(err?.message);
      });
  };

  const handleBtnClick = (name) => {
    setActiveBtn(name);
  };

  const postTrendingCount = (id) => {
    if (checkBackId != id) {
      var isViews = true;
      userService.trendingViewPost(isViews, id).then((res) => {
        getTrendingData(schoolId);
        setCheckBackId(id);
      });
    }
  };
  return (
    <div>
      <Paper className="activity-trending-container mg-left-auto pd-15">
        <h2 className="fs-28 bold black mobofs36">Trending</h2>
        <div className="activity-trending-btn-container">
          <Buttons
            buttonData={button_data2}
            activebtn={activeBtn}
            handleClick={handleBtnClick}
          />
        </div>
      </Paper>
      <div className="clear10"></div>
      <div className="height-350 overflow-y mg-top-10">
        {trendingVideos?.map((item, index) => (
          <div
            key={index}
            className="main-card-box pd-10 brd-grey d-flex mng-home-cont-width mg-left-auto brd-grey"
          >
            <div className="trending-video-super-container">
              <div className="trending-video-container">
                <video
                  src={item.eventMedia.videoPath}
                  className="trending-video-player cp"
                  onClick={() => {
                    openVideoPopup(dispatch, {
                      status: true,
                      videoURL: item.eventMedia.videoPath,
                    });
                    postTrendingCount(item?.shareMediaId);
                  }}
                />
              </div>
            </div>
            <div className="info-container">
              <p className="fs-18 bold">
                {item?.school1Name} <span className="skBlue cp">Vs</span>{" "}
                {item?.school2Name} | {item?.videoTitle}
              </p>
              <div className="clear10"></div>
              <span className="fs-14 medium colorb4">
                {item?.trendingViewsCount} views{" "}
              </span>
              <div className="greydot disin"></div>
              <span className="fs-14 medium colorb4">{item?.lastSeen}</span>
              <div className="clear10"></div>
              <LimitedTextContainer text={item?.videoDescription} />
            </div>
          </div>
        ))}
        {trendingVideos?.length === 0 && !error && (
          <Paper className="activity-trending-container2 mg-left-auto pd-10 mg-top-10">
            <p className="nodatabox">
              No feed available currently. Once you or your Coaches, Athletes
              share the content, it will become available here
            </p>
          </Paper>
        )}

        {error && (
          <Paper className="activity-trending-container2 mg-left-auto pd-10 mg-top-10">
            <p className="nodatabox">{error}</p>
          </Paper>
        )}
      </div>
    </div>
  );
};

export default HomeTrending;
